import ApiInstance from './intercepter';
import API from '../config/api';

export const createAdvertisingInterest = params => ApiInstance.post(API.ADVERTISING_CREATE, params);
